/* Nordic Store – header menus + sale prices.
 * The sale part is the same DEALS setup as the live theme's custom.js (1 Oct 2026), moved to this design.
 * everyone: true -> every visitor sees the sale. everyone: false -> only visitors from a link ending in ?deal=CODE.
 * Preview before a sale starts: add ?deal=CODE&deal_preview=1 to any page URL. */
(function () {
  'use strict';
  var DEALS = {
    COFFEE25: {
      everyone: true, percent: 25,
      starts: '2026-10-01T12:35:00Z', ends: '2026-10-04T23:59:59Z',
      bar: 'International Coffee Day: 25% off Icelandic mugs', barExtra: 'Ends Sunday 4 October',
      barLink: '/collections/mugs', barCta: 'Shop mugs', label: '25% off',
      note: 'Coffee Day sale: 25% off, taken off automatically at checkout.',
      handles: ['mug-jazz-puffin-silhouette-blue','mug-jazz-puffin-silhouette-red','mug-jazz-puffin-family-blue','mug-jazz-puffin-family-red','mug-jazz-hallgrimskirkja-blue','mug-jazz-hallgrimskirkja-red','mug-jazz-viking-blue','mug-jazz-viking-red','mug-two-tone-iceland-puffin','mug-two-tone-iceland-horse','mugg-two-tone-iceland-puffin-horse-volcano','mugg-horn-vikings-flames-iceland']
    },
    LEIF20: {
      everyone: false, percent: 20,
      starts: '2026-10-06T00:00:00Z', ends: '2026-10-11T23:59:59Z',
      bar: 'Leif Erikson Day: 20% off all wool sweaters', barExtra: 'Ends Sunday 11 October',
      barLink: '/collections/icelandic-wool-sweaters', barCta: 'Shop sweaters', label: '20% off',
      note: 'Leif Erikson Day sale: 20% off, taken off automatically at checkout.',
      handles: ['icelandic-sweater-traditional-blue-men','icelandic-sweater-skipper-pullover-grey-men','icelandic-sweater-traditional-grey-men','icelandic-sweater-skipper-pullover-woman-white','icelandic-sweater-skipper-hood-woman-grey','icelandic-sweater-traditional-black-men','icelandic-sweater-skipper-pullover-grey-woman','icelandic-sweater-traditional-blue-woman','icelandic-sweater-traditional-grey-woman','icelandic-sweater-skipper-hood-woman-white','icelandic-sweater-fonn-woman-blue','icelandic-sweater-skipper-pullover-men-black','icelandic-sweater-skipper-hood-woman-black-1','icelandic-sweater-fonn-woman-black','icelandic-sweater-traditional-black-woman','icelandic-sweater-skipper-hood-men-black','icelandic-sweater-skipper-hood-men-grey','icelandic-sweater-skipper-men-grey','icelandic-sweater-skipper-pullover-black-woman','icelandic-sweater-skipper-men-black','icelandic-sweater-skipper-cardigan-woman-white','icelandic-sweater-skipper-woman-grey','icelandic-sweater-skipper-hood-men-white','icelandic-sweater-fonn-men-black','icelandic-sweater-skipper-woman-black','icelandic-sweater-skipper-pullover-men-white','bjarni-wool-brown-icelandic-sweater','icelandic-sweater-eykt-blue','icelandic-sweater-eykt-grey','icelandic-sweater-hruni-blue','icelandic-sweater-tight-fit-black','icelandic-sweater-gudbjartur-black','icelandic-sweater-skipper-cardigan-men-white','icelandic-sweater-tight-fit-white','icelandic-sweater-hruni-black','icelandic-sweater-hruni-red','eykt-wool-pullover-yellowicelandicsweater','icelandic-sweater-hruni-green','icelandic-sweater-eykt-red','icelandic-sweater-hruni-grey','icelandic-sweater-eykt-brown','icelandic-sweater-gudbjartur-sheep','wool-vest-whiteicelandicsweater','woolvestgreyicelandicsweater','icelandic-sweater-eykt-green','woolvestblackicelandicsweater','fonn-wool-sweater-grey','bjarni-wool-cardigan-grey','tight-fit-wool-pullover-dark-grey','hruni-wool-cardigan-icelandic-sweater-hruni-brown','icelandic-sweater-goa-brown','eykt-wool-pullover-black','eykt-wool-pullover-rose-heather','hruni-wool-cardigan-light-green','hruni-wool-cardigan-dark-red','icelandic-sweater-goa-grey']
    }
  };
  var STORE_KEY = 'ns_email_deal';
  function readStored() {
    try { return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || window.localStorage.getItem(STORE_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function store(code, preview) {
    try {
      var value = JSON.stringify({ code: code, preview: !!preview });
      if (preview) { window.sessionStorage.setItem(STORE_KEY, value); } else { window.localStorage.setItem(STORE_KEY, value); }
    } catch (e) {}
  }
  function isRunning(code, preview) {
    var deal = DEALS[code];
    if (!deal) return false;
    if (preview) return true;
    var now = Date.now();
    return now >= Date.parse(deal.starts) && now <= Date.parse(deal.ends);
  }
  function activeCode() {
    var s = readStored();
    if (s && isRunning(s.code, s.preview)) return s.code;
    for (var code in DEALS) { if (DEALS[code].everyone && isRunning(code, false)) return code; }
    return null;
  }
  try {
    var params = new URLSearchParams(window.location.search);
    var urlCode = (params.get('deal') || '').toUpperCase();
    if (DEALS[urlCode]) store(urlCode, params.get('deal_preview') === '1');
  } catch (e) {}
  var cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  if (cookieMatch && !activeCode()) {
    var cookieCode = decodeURIComponent(cookieMatch[1]).toUpperCase();
    if (DEALS[cookieCode]) store(cookieCode, false);
  }

  // "$259.99" -> same price with the discount taken off, same currency sign and number style
  function discountText(text, percent) {
    var m = (text || '').match(/\d[\d.,\s ']*\d|\d/);
    if (!m) return null;
    var raw = m[0].replace(/[\s ]+$/, '');
    var dm = raw.match(/[.,](\d{2})$/);
    var dec = dm ? raw.charAt(raw.length - 3) : '';
    var intPart = dm ? raw.slice(0, -3) : raw;
    var thouMatch = intPart.match(/[^\d]/);
    var thou = thouMatch ? thouMatch[0] : '';
    var cents = parseInt(intPart.replace(/[^\d]/g, ''), 10) * 100 + (dm ? parseInt(dm[1], 10) : 0);
    if (!cents) return null;
    var saleCents = cents - Math.round(cents * percent / 100);
    if (!dm) saleCents = Math.round(saleCents / 100) * 100;
    var whole = String(Math.floor(saleCents / 100));
    if (thou) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var frac = saleCents % 100;
    return text.replace(raw, whole + (dm ? dec + (frac < 10 ? '0' : '') + frac : ''));
  }
  function setSale(el, original, sale) {
    el.textContent = '';
    var s = document.createElement('span'); s.className = 'ns-sale'; s.textContent = sale;
    var o = document.createElement('s'); o.textContent = original;
    el.appendChild(s); el.appendChild(document.createTextNode(' ')); el.appendChild(o);
  }
  function applyBar(deal) {
    var bar = document.getElementById('ns-topbar');
    if (!bar || !deal.bar || bar.getAttribute('data-ns-deal')) return;
    bar.setAttribute('data-ns-deal', '1');
    bar.classList.add('ns-topbar--sale');
    bar.textContent = '';
    var link = document.createElement('a'); link.href = deal.barLink || '#';
    var label = document.createElement('span'); label.className = 'ns-topbar__label'; label.textContent = 'Sale';
    var text = document.createElement('span'); text.textContent = deal.bar;
    link.appendChild(label); link.appendChild(text);
    if (deal.barExtra) { var ex = document.createElement('span'); ex.className = 'ns-topbar__extra'; ex.textContent = deal.barExtra; link.appendChild(ex); }
    if (deal.barCta) { var cta = document.createElement('span'); cta.className = 'ns-topbar__cta'; cta.textContent = deal.barCta + ' →'; link.appendChild(cta); }
    bar.appendChild(link);
  }
  function applyCards(deal) {
    var cards = document.querySelectorAll('.ns-card[data-handle]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (deal.handles.indexOf(card.getAttribute('data-handle')) === -1) continue;
      var price = card.querySelector('.ns-card__price');
      if (!price || price.getAttribute('data-ns-deal') || price.querySelector('s')) continue;
      var original = price.textContent.replace(/\s+/g, ' ').trim();
      var sale = discountText(original, deal.percent);
      if (!sale) continue;
      price.setAttribute('data-ns-deal', '1');
      setSale(price, original, sale);
      var img = card.querySelector('.ns-card__img');
      if (deal.label && img && !img.querySelector('.ns-badge')) {
        var tag = document.createElement('span'); tag.className = 'ns-badge'; tag.textContent = deal.label; img.appendChild(tag);
      }
    }
  }
  function applyProduct(deal) {
    var marker = document.querySelector('[data-ns-pdp-handle]');
    if (!marker || deal.handles.indexOf(marker.getAttribute('data-ns-pdp-handle')) === -1) return;
    var info = marker.closest('.product__info-container') || document;
    var price = info.querySelector('.price');
    if (!price || price.classList.contains('price--on-sale')) return;
    var reg = price.querySelector('.price__regular .price-item--regular') || price.querySelector('.price-item--regular');
    if (!reg || reg.getAttribute('data-ns-deal')) return;
    var original = reg.textContent.replace(/\s+/g, ' ').trim();
    var sale = discountText(original, deal.percent);
    if (!sale) return;
    reg.setAttribute('data-ns-deal', '1');
    setSale(reg, original, sale);
    if (deal.note && !info.querySelector('.ns-deal-note')) {
      var block = price.closest('[id^="price-"]') || price;
      var note = document.createElement('p'); note.className = 'ns-deal-note'; note.textContent = deal.note;
      block.parentNode.insertBefore(note, block.nextSibling);
    }
  }
  function applyDeals() {
    var code = activeCode();
    if (!code) return;
    var deal = DEALS[code];
    applyBar(deal); applyCards(deal); applyProduct(deal);
  }

  // Header: Wool & Knitting mega menu, phone menu, search box
  function initHeader() {
    var header = document.querySelector('[data-ns-header]');
    if (!header) return;
    var trigger = header.querySelector('[data-ns-mega-trigger]');
    var mega = header.querySelector('[data-ns-mega]');
    var canHover = window.matchMedia('(hover: hover)');
    function open() { header.classList.add('is-mega-open'); if (trigger) trigger.setAttribute('aria-expanded', 'true'); }
    function close() { header.classList.remove('is-mega-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); }
    if (trigger && mega) {
      trigger.addEventListener('mouseenter', function () { if (canHover.matches) open(); });
      trigger.addEventListener('focus', open);
      trigger.addEventListener('click', function (e) {
        if (!canHover.matches && !header.classList.contains('is-mega-open')) { e.preventDefault(); open(); }
      });
      header.addEventListener('mouseleave', close);
      var links = header.querySelectorAll('.ns-nav a');
      for (var i = 0; i < links.length; i++) {
        if (links[i] !== trigger) { links[i].addEventListener('mouseenter', close); links[i].addEventListener('focus', close); }
      }
      var top = header.querySelector('.ns-header__top');
      if (top) top.addEventListener('mouseenter', close);
      mega.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    var drawer = header.querySelector('[data-ns-drawer]');
    if (drawer) {
      drawer.addEventListener('toggle', function () { document.documentElement.classList.toggle('ns-lock', drawer.open); });
      var closeBtn = drawer.querySelector('[data-ns-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { drawer.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) drawer.open = false; });
    }
    var search = header.querySelector('[data-ns-search]');
    if (search) {
      search.addEventListener('toggle', function () {
        if (!search.open) return;
        close();
        var input = search.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 30);
      });
      document.addEventListener('click', function (e) { if (search.open && !search.contains(e.target)) search.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && search.open) search.open = false; });
    }
  }

  function start() {
    initHeader();
    applyDeals();
    if (!activeCode()) return;
    var timer;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(applyDeals, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();